import React, { Component, Fragment } from 'react';
import { browserHistory } from 'react-router';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Loading from 'components/Loading/Loading';
import TeacherReservationListCompact from 'components/TeacherReservationListCompact';
import { RESERVATIONS_MODE } from 'config/constants';
import { fetchBookings, fetchBookingHistory, fetchPendingBookings } from 'actions/bookingActions';
import { openModal } from 'actions/modalActions';

import './style.css';

class TeacherScheduleReservations extends Component {
  constructor(props) {
    super(props);
    let mode;
    if (props.location.query.view === 'all') {
      mode = 'all';
    } else if (props.location.query.view === 'pending') {
      mode = 'pending';
    } else {
      mode = 'upcoming';
    }
    this.state = {
      mode: mode,
      currentPage: 0
    };
  }

  componentDidMount() {
    if (this.props.user.id) {
      this.loadBookings(this.state.mode);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.user.id && prevProps.user.id !== this.props.user.id) {
      this.loadBookings(this.state.mode);
    }
  }

  loadBookings = (mode, page) => {
    if (mode === RESERVATIONS_MODE.ALL) {
      this.props.fetchBookingHistory(page);
    } else if (mode === RESERVATIONS_MODE.PENDING) {
      this.props.fetchPendingBookings(page);
    } else {
      this.props.fetchBookings(page);
    }
  }

  handleClickMode = (mode) => {
    return (event) => {
      event.preventDefault();
      this.setState({ mode });
      let query;
      if (mode === RESERVATIONS_MODE.ALL) {
        query = '?view=all';
      } else if (mode === RESERVATIONS_MODE.PENDING) {
        query = '?view=pending';
      } else {
        query = '';
      }
      browserHistory.push(this.props.location.pathname + query);
      this.loadBookings(mode);
    };
  }

  handlePaginationClick = (data) => {
    const { selected: page } = data;
    const { mode } = this.state;
    this.setState({ currentPage: page });
    this.loadBookings(mode, page);
  }

  handleConfirmButtonClick = (reservation) => {
    const { mode } = this.state;
    this.props.openModal('teacher-lesson-confirmation-modal', {
      lessonId: reservation.id,
      reloadBookings: () => this.loadBookings(mode)
    });
  }

  renderPendingBookingsBadge = () => {
    const { pendingBookingsStatus, totalBookings } = this.props;
    const { mode } = this.state;
    if (pendingBookingsStatus === 'SUCCESS' && totalBookings > 0 && mode === RESERVATIONS_MODE.PENDING) {
      return (<span className="badge badge-primary">{totalBookings}</span>)
    }
  }

  render() {
    const { mode } = this.state;
    const { reservationsStatus, periodBookingsStatus, pendingBookingsStatus } = this.props;

    return (
      <div className="teacher-schedule-reservations full-height card d-flex">
        <div className="px-4 px-lg-5 pt-4 pt-lg-5">
          <h4 className="mb-0">Reservations</h4>
          <div className="teacher-schedule-reservations__header d-flex align-items-center justify-content-between mt-4">
            <ul className="nav">
              <li className="nav-item">
                <a
                  href="#"
                  className={classnames('nav-link mr-2 mr-sm-4 mr-lg-5', {
                    active: mode === RESERVATIONS_MODE.UPCOMING
                  })}
                  onClick={this.handleClickMode(RESERVATIONS_MODE.UPCOMING)}
                >
                  Upcoming
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#"
                  className={classnames('nav-link mr-2 mr-sm-4 mr-lg-5', {
                    active: mode === RESERVATIONS_MODE.PENDING
                  })}
                  onClick={this.handleClickMode(RESERVATIONS_MODE.PENDING)}
                >
                  Pending {this.renderPendingBookingsBadge()}
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#"
                  className={classnames('nav-link mr-2 mr-sm-4 mr-lg-5', {
                    active: mode === RESERVATIONS_MODE.ALL
                  })}
                  onClick={this.handleClickMode(RESERVATIONS_MODE.ALL)}
                >
                  All
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="d-flex flex-column teacher-schedule-reservations__content px-4 px-lg-5">
          {mode === RESERVATIONS_MODE.UPCOMING && (
            <Fragment>
              {reservationsStatus === 'LOADING' && <Loading />}
              {reservationsStatus === 'SUCCESS' && (
                <TeacherReservationListCompact
                  reservations={this.props.reservations || []}
                  currentUser={this.props.user}
                  total={this.props.totalBookings}
                  pageSize={this.props.pageSize}
                  page={this.state.currentPage}
                  handlePaginationClick={this.handlePaginationClick}
                />
              )}
            </Fragment>
          )}
          {mode === RESERVATIONS_MODE.PENDING && (
            <Fragment>
              {pendingBookingsStatus === 'LOADING' && <Loading />}
              {pendingBookingsStatus === 'SUCCESS' && (
                <TeacherReservationListCompact
                  reservations={this.props.pendingBookings || []}
                  currentUser={this.props.user}
                  total={this.props.totalBookings}
                  pageSize={this.props.pageSize}
                  page={this.state.currentPage}
                  handleConfirmButtonClick={this.handleConfirmButtonClick}
                  handlePaginationClick={this.handlePaginationClick}
                />
              )}
            </Fragment>
          )}
          {mode === RESERVATIONS_MODE.ALL && (
            <Fragment>
              {periodBookingsStatus === 'LOADING' && <Loading />}
              {periodBookingsStatus === 'SUCCESS' && (
                <TeacherReservationListCompact
                  reservations={this.props.periodBookings || []}
                  currentUser={this.props.user}
                  total={this.props.totalBookings}
                  pageSize={this.props.pageSize}
                  page={this.state.currentPage}
                  handlePaginationClick={this.handlePaginationClick}
                />
              )}
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    reservations: state.bookings.bookings,
    reservationsStatus: state.bookings.status,
    periodBookings: state.bookings.periodBookings,
    totalBookings: state.bookings.totalBookings,
    pageSize: state.bookings.pageSize,
    periodBookingsStatus: state.bookings.periodBookingsStatus,
    pendingBookings: state.bookings.pendingBookings,
    pendingBookingsStatus: state.bookings.pendingBookingsStatus,
  };
}

export default connect(mapStateToProps, {
  fetchBookings,
  fetchBookingHistory,
  fetchPendingBookings,
  openModal
})(TeacherScheduleReservations);



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Reservations/index.js